import { render } from "./Setsetset.vue?vue&type=template&id=f2925b34"
import script from "./Setsetset.vue?vue&type=script&lang=js"
export * from "./Setsetset.vue?vue&type=script&lang=js"

import "./Setsetset.vue?vue&type=style&index=0&id=f2925b34&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__